/**
 * 現在のページのスクロール位置を返します。
 * @param {HTMLElement} el
 * @return {object} {x, y} 横スクロールと縦スクロール量
 */
export default function getScrollPosition(el = window) {
  return {
    x: el.pageXOffset !== undefined ? el.pageXOffset : el.scrollLeft,
    y: el.pageYOffset !== undefined ? el.pageYOffset : el.scrollTop,
  };
}
